const imagesList = {
  // 'clinical-biochemistry': () => import('../../Assets/ClinicalBiochemistry.png'),
  'histology-analysis': () => import('../../Assets/HistologyAnalysis.png'),
  'research-development': () => import('../../Assets/ResearchDevelopment.png'),
  'training-internship': () => import('../../Assets/TrainingIntership.png'),
  'waste-management': () => import('../../Assets/WasteManagement.jpg'),
  'microbiology': () => import('../../Assets/Microbiology.jpg'),
  'phytochemistry': () => import('../../Assets/Phytochemistry.png'),
  'nanotechnology': () => import('../../Assets/Nanotechnology.png'),
  'environmental-analysis': () => import('../../Assets/EnvironmentalAnalysis.png'),
  'proteomics': () => import('../../Assets/Proteomics.png'),
  'genomics': () => import('../../Assets/Genomics.png'),
  'dental-medical': () => import('../../Assets/DentalMedical.png'),
  'biomedical-animal-studies': () => import('../../Assets/BiomedicalAnimalStudies.png'),
  'bioinformatics': () => import('../../Assets/Bioinformatics.png'),
  'clinical-diagnosis': () => import('../../Assets/ClinicalDiagnosis.png'),
  'scientific-writing': () => import('../../Assets/ScientificWriting.png'),
};

export default imagesList;